import React, { Component } from 'react'
import "./style.css"
import "./style.mobile.css"
import BuildInMapTool from './tool-item/buildin-map'
import FullscreenTool from './tool-item/fullscreen'
import HomeTool from './tool-item/home'
import InfoTool from './tool-item/info'
import MapTool from './tool-item/map'
import MusicTool from './tool-item/music'
import NavigatorTool from './tool-item/navigator'
import PlayTool from './tool-item/play'
import SearchTool from './tool-item/search'
import ShareTool from './tool-item/share'
import VRTool from './tool-item/vr'


export default class Toolbar extends Component {

    getControlToolView() {
        var toolIndex = Object.keys(window.config.toolbar);
        const toolMap = {
            play: () => <PlayTool />,
            search: () => <SearchTool sceneData={this.props.vrtour?.content?.scene ?? []} />,
            home: () => <HomeTool />,
            vr: () => <VRTool />,
            buildin_map: () => <BuildInMapTool />,
            map: () => <MapTool {...this.props} />,
            share: () => <ShareTool />,
            info: () => <InfoTool dataset={this.props.vrtour?.content} />,
            music: () => <MusicTool play={this.props.app_isReady} />,
            full: () => <FullscreenTool />
        }
        var sortedToolbar = toolIndex.map(key => toolMap[key] && toolMap[key]());
        return [
            <NavigatorTool type="prev" vrtour={this.props.vrtour?.content} />,
            ...sortedToolbar,
            <NavigatorTool type="next" vrtour={this.props.vrtour?.content} />,
        ]
    }

    render() {
        var { nav_isCollapseNav, setting_isWidescreenOn } = this.props;
        var navStatusExpand = nav_isCollapseNav ? "" : " nav-status-expand";
        var menuStatusSettingHidden = setting_isWidescreenOn & nav_isCollapseNav ? " setting-autowide" : "";

        return (
            <div className={"toolbar-place" + navStatusExpand + menuStatusSettingHidden}>
                <div className="control-tools">
                    {this.getControlToolView.call(this)}
                </div>
            </div>
        )
    }
}
